import Typography from "typography";
import stowLakeTheme from "typography-theme-stow-lake";

const typography = new Typography(stowLakeTheme);

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js